import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {message, Modal} from 'antd';
import {getAllVehicles, selectVehicles, removeMonitorVehicle} from '../../redux/slices/vehicles';
import {getAllBranches, selectBranches} from '../../redux/slices/branches';
import VehiclesUI from './components/VehiclesUI';

const Vehicles = () => {
  const [loading, handleLoading] = useState(true);
  const [editorVisible, handleEditorVisible] = useState(false);
  const [vehicle, handleVehicle] = useState(null);
  const vehicles = useSelector(selectVehicles);
  const branches = useSelector(selectBranches);
  const dispatch = useDispatch();

  useEffect(() => {
    const initialFetch = async () => {
      const [response, res_branches] = await Promise.all([
        dispatch(getAllVehicles()),
        dispatch(getAllBranches())
      ]);
      if (response.status !== 'success') {
        message.error('¡Hubo un problema!');
      }
      handleLoading(false);
    };
    initialFetch();
  }, [dispatch]);


  const openEditor = vehicleToEdit => {
    handleVehicle(vehicleToEdit);
    handleEditorVisible(true);
  };

  const newVehicle = () => {
    handleVehicle(null);
    handleEditorVisible(true);
  };

  const closeEditor = () => {
    handleVehicle(null);
    handleEditorVisible(false);
  };

  const confirmDelete = idVehicle => {
    Modal.confirm({
      title: '¿Estás segúro de eliminar este vehiculo?',
      content: 'Esta información no se podrá recuperar.',
      okText: 'Eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      async onOk() {
        await removeVehicle(idVehicle);
      },
      onCancel() {},
    });
  };

  const removeVehicle = async (idVehicle) => {
    const response = await dispatch(removeMonitorVehicle(idVehicle));
    if (response.status !== 'success') {
      message.error('¡Hubo un problema!');
    } else {
      message.success('Vehiculo eliminada correctamente');
    }
  }

  return (
    <VehiclesUI
      loading={loading}
      branches={branches}
      vehicle={vehicle}
      vehicles={vehicles}
      openEditor={openEditor}
      editorVisible={editorVisible}
      closeEditor={closeEditor}
      newVehicle={newVehicle}
      confirmDelete={confirmDelete}
      handleVehicle={handleVehicle}
    />
  );
}

export default Vehicles;
